import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { questionnaireItemsActions } from '../../../../core/questionnaire-items/actions';

import { QuestionsList } from '../../../components/questionnaires/questions-review/QuestionsList';
import { ModalSubmitAssessment } from '../../../components/common/assessments-modals';
import { api } from '../../../../core/api/api-service';
import { userActions } from '../../../../core/users';
import { systemActions } from '../../../../core/system';
import { SYSTEM_ID_NEXT_ASSESSMENT } from '../../../../core/constants';

export const QuestionnaireReview = (params) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const user = useSelector(state => state.user );
    const questionnaire_list = useSelector(state => state.questionnaire_list);
    const [openModalConfirm, setOpenModalConfirm] = useState(false);

    const loadQuestionnaireItems = () => {
        dispatch(questionnaireItemsActions.loadQuestionnaireItems(Number(id !== undefined ? id : params.id)));
    }

    useEffect(() => {
        loadQuestionnaireItems();
    }, [id, params?.id]);

    const handleConfirmSave = () => {
        if (user?.assessments_block_days) {
            setOpenModalConfirm(true);
        }
        else {
            handleSubmit();
        }
    }

    const handleSubmit = () => {
        api.fetchQuestionnaireSubmit({ id })
        .then(() => {
            dispatch(userActions.currentUser());
            dispatch(systemActions.loadSystem(SYSTEM_ID_NEXT_ASSESSMENT));
        });
        setOpenModalConfirm(false);
    }

    return (
        <>
            <div className='w-100'>
                <div className='mb-3 pt-md-4'>
                    <h1 className='mb-2 libre-caslon-text-regular h4 h3-md'> {!questionnaire_list?.data?.questionnaire?.submitted && 'Review your answers - '} {questionnaire_list?.data?.questionnaire?.name}</h1>
                    <p className='mb-0'>click on each question to expand and review your selection.</p>
                </div>

                {!questionnaire_list?.isPending && <div className="p-md-3 mb-5 border-md rounded">
                    <QuestionsList questionnaire={questionnaire_list?.data}/>
                </div>}

                {!questionnaire_list?.data?.questionnaire?.submitted &&
                    <div className="d-flex justify-content-center">
                        <Button size='sm' color='green-light' onClick={handleConfirmSave}>
                            <i className='mr-2'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill='currentColor' style={{marginBottom: '1px'}}>
                            <path d="M12.7,4.4l-7,7c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1
                                L1.7,8.3C1.7,8.3,1.6,8.2,1.6,8.1C1.5,8,1.5,8,1.5,7.9c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1
                                c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.1L5.2,10l6.5-6.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.3,0.1,0.5,0.2
                                c0.1,0.1,0.2,0.3,0.2,0.5C12.9,4.1,12.8,4.3,12.7,4.4L12.7,4.4z"/>
                            </svg>
                            </i>
                            Submit Assessment
                            </Button>
                    </div>
                }
            </div>
            <ModalSubmitAssessment
                isOpen={openModalConfirm}
                close={() => setOpenModalConfirm(false)}
                onAccept={handleSubmit}
                onCancel={() => setOpenModalConfirm(false)}
                blockDays={user?.assessments_block_days}
            />
        </>
    )
}